module.exports = __webpack_public_path__ + "img/urban@2x.d2f1cca.webp";